import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#197052",
                secondary: "#701937"
            },
            dark: {
                primary: "#197052",
                secondary: "#701937"
            }
        }
    }
});
